'use client';
/** @jsxImportSource @emotion/react */

import type { ImageListItemBarProps } from '@mui/material/ImageListItemBar';

import MuiImageListItemBar from '@mui/material/ImageListItemBar';

export type { ImageListItemBarProps };
export const ImageListItemBar = MuiImageListItemBar;
